
document.addEventListener('DOMContentLoaded', function() {
    const tabComponents = document.querySelectorAll('.ce_rsce_tabElement, .ce_rsce_textBildTab');

    tabComponents.forEach(component => {
        const tabs = component.querySelectorAll('.tabs .tab');
        const contents = component.querySelectorAll('.container-inner.tabElement > .tabElement');

        if (!tabs.length || !contents.length) {
            return;
        }

        const activatePane = targetId => {
            const targetPane = component.querySelector(`.container-inner.tabElement > .tabElement[data-content="${targetId}"]`);

            if (!targetPane) {
                return;
            }

            tabs.forEach(tab => {
                tab.classList.toggle('active', tab.getAttribute('data-id') === targetId);
            });

            contents.forEach(content => {
                const isTarget = content === targetPane;

                content.classList.remove('is-entering');
                content.classList.toggle('active', isTarget);
            });

            // Restart the enter animation on every tab change.
            void targetPane.offsetWidth;
            targetPane.classList.add('is-entering');
        };

        tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                const targetId = this.getAttribute('data-id');

                if (this.classList.contains('active')) {
                    return;
                }

                activatePane(targetId);
            });
        });
    });
});
